import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query';
import { auth } from '../firebase';
import type { RootState } from '../store';
import { ProductResult, ProductQuery, ProductIdArgs } from './models';
import { transformProductResponse } from './models-transformers';
import { isEqual } from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface ApiState {
  queries: Record<string, ProductQuery>;
}

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/product',
    prepareHeaders: async (headers) => {
      // Add the Authorization header dynamically before each request
      const token = auth.currentUser ? await auth.currentUser.getIdToken(false) : null;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProduct: builder.query<ProductQuery, ProductIdArgs>({
      query: (args: ProductIdArgs) => `${args.product_id}`,
      // @ts-ignore
      transformResponse: (response: ProductResult): ProductResult => transformProductResponse(response),
    }),
  }),
});

export const selectApiState = (state: any): ApiState => state.productApi;

// Selector to get the result for a specific product
export const selectProductQuery = (
  state: RootState,
  args: ProductIdArgs
): ProductQuery | null => {
  const found = Object.values(selectApiState(state).queries).filter(
    (item) =>
      item.endpointName === 'getProduct' &&
      isEqual(item.originalArgs, args)
  );
  return found.length ? found[0] : null;
};

export const prefetchProduct = createAsyncThunk<
  void,
  ProductIdArgs,
  any
>(
  'products/prefetch',
  async (action: ProductIdArgs, thunkAPI) => {
    // Dispatch the RTK Query API call
    await thunkAPI.dispatch(productApi.endpoints.getProduct.initiate({ product_id: action.product_id }));
  }
);

